const MessagesThreads = {
  components: {
    ThreadTitle: _messageTitle,
  },
  data() {
    return {
      now: new Date(),
      selected: false,
      archived: false,
    };
  },
  props: {
    tid: { default: false },
    threads: { default: [] },
  },
  computed: {
    autoSelect() {
      return $('body').width() >= 920;
    },
    visibleThreads() {
      return this.threads
        .filter((t) => {
          return this.archived
            ? t.status !== 'publish'
            : t.status === 'publish';
        })
        .sort((a, b) => {
          if (a.status !== b.status) {
            if (a.status === 'published') return -1;
            if (b.status === 'published') return 1;
            return 0;
          }
          const $a = new Date(a.updatedAt).getTime();
          const $b = new Date(b.updatedAt).getTime();
          return $b - $a;
        });
      // .filter((thread) => {
      //   return this.archived ? true : thread.status === 'publish';
      // });
    },
    ...Vuex.mapState(['user']),
  },
  watch: {
    tid(value, old) {
      if (!value) {
        this.selected = null;
      }
    },
    archived() {
      if (this.autoSelect) {
        this.select(this.visibleThreads[0]);
      }
    },
    threads() {
      this.updateNow();
    },
  },
  created() {
    this.init();
    setInterval(this.updateNow, 50000);
  },
  methods: {
    init() {
      if (this.tid) {
        const thread = this.threads.filter((t) => t._id === this.tid)[0];
        if (thread.status !== 'publish') {
          this.archived = true;
        }
        this.select(thread);

        //scrolleamos para que se vea
        this.$nextTick(function () {
          // this.$el.querySelector('li.-selected').scrollIntoView({
          //   block: 'center',
          //   behavior: 'smooth',
          // });
          const scrollY =
            this.$el.querySelector('li.-selected').offsetTop -
            this.$el.clientHeight / 2;

          this.$el.scrollTo(0, scrollY);
          window.scrollTo(0, 0);
        });
      } else if (this.autoSelect) {
        if (this.visibleThreads.length) {
          this.select(this.visibleThreads[0]);
        } else {
          this.archived = true;
          this.select(this.threads[0]);
        }
      }
    },
    select(thread) {
      //console.log('thread.select', this.selected, thread);
      if (this.selected && thread._id === this.selected._id) {
        return;
      }
      thread.unread = false;
      this.selected = thread;
      this.$emit('select', thread);
    },
    updateNow() {
      this.now = new Date().getTime() + 5000;
    },
  },
  template: `
    <div class="threads">
    <transition-group name="flip-list" tag="ul" class="uk-list uk-flex-bottom">
      <li
        @click="archived = false"
        class="archive" key="non-archived"
        v-show="archived">
        <i class="icon-chevron-left"></i>
        Volver
      </li>
      <li
          :key="thread._id"
          @click="select(thread)"
          v-for="thread in visibleThreads"
          :class="{ '-selected': selected && thread._id === selected._id, '-unread': thread.unread }"
      >
        <div class="uk-overflow-hidden">
          <small class="uk-float-right" :title="thread.updatedAt | dateFormat">
            {{ thread.updatedAt | relativeTime(now) }}
          </small>
          <ThreadTitle :thread="thread"></ThreadTitle>
        </div>
      </li>
      <li 
        @click="archived = true" 
	      class="archive" key="archived" 
	      v-show="!archived && threads.length > visibleThreads.length">
        Ver mensajes archivados
      </li>
    </transition-group>
    </div>
  `,
};
